import { render, staticRenderFns } from "./DynamicContentCoachAppSpecialEvents.vue?vue&type=template&id=56751585"
import script from "./DynamicContentCoachAppSpecialEvents.vue?vue&type=script&lang=js"
export * from "./DynamicContentCoachAppSpecialEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports